import React from 'react';
import { useMEDispatch } from './MovementEnquiry.context';
import { RouteComponentProps } from 'react-router';
import { IKitDetail } from 'api/swaggerTypes';

export enum PickSlipAPIType {
    deleteGridLine = 'deleteGridLine',
    updateGridLine = 'updateGridLine',
    updateLine = 'updateLine',
}

export const useTabLocations = (url: string, location: RouteComponentProps['location']) => {

    const contextDispatch = useMEDispatch();
    const urlParams = new URLSearchParams(location.search);
    const ProductId = urlParams.get('ProductId') || '';
    const MovementId = urlParams.get('MovementId') || '';
    const LineNumber = urlParams.get('MovementLineNo') || '';

    const tabLocations = React.useMemo(
        () => {

            return ({
                MovementEnquiryDetails: {
                    pathname: url,
                    search: `?ProductId=${ProductId || ''}&MovementId=${MovementId || ''}&MovementLineNo=${LineNumber || ''}`
                },
                Transactions: {
                    pathname: `${url.endsWith('/') ? url : `${url}/`}transactions`,
                    search: `?ProductId=${ProductId || ''}&MovementId=${MovementId || ''}&MovementLineNo=${LineNumber || ''}`
                },
                BinLocations: {
                    pathname: `${url.endsWith('/') ? url : `${url}/`}bin-locations`,
                    search: `?ProductId=${ProductId || ''}&MovementId=${MovementId || ''}&MovementLineNo=${LineNumber || ''}`
                },
                LotDetails: {
                    pathname: `${url.endsWith('/') ? url : `${url}/`}lot-details`,
                    search: `?ProductId=${ProductId || ''}&MovementId=${MovementId || ''}&MovementLineNo=${LineNumber || ''}`
                },
                SerialNumbers: {
                    pathname: `${url.endsWith('/') ? url : `${url}/`}serial-numbers`,
                    search: `?ProductId=${ProductId || ''}&MovementId=${MovementId || ''}&MovementLineNo=${LineNumber || ''}`
                },
            });
        },
        [url]
    );

    React.useEffect(
        () => {
            const params = (new URLSearchParams(location.search));
            const MovementEnquiryParam = params.get('MovementEnquiry') || '';
            const LineNumberParam = params.get('LineNumber') || '';

            contextDispatch({
                setMovementEnquiry: MovementEnquiryParam,
                setLineNumber: Number(LineNumberParam),
            });
        },
        [contextDispatch]
    );

    return {
        tabLocations
    };
};

type BomApis = 'addLine' | 'calculateFastEntry' | 'updateGridLine' | 'calculateGridLine' | 'update' | 'load';

export const usePriceOverrideAndKitValidations = () => {
    const [multipleBomOpen, setMultipleBomState] = React.useState<boolean>(false);
    const [bomList, setBomList] = React.useState<IKitDetail[]>([]);
    const [kitStatus, setKitStatus] = React.useState<string>('');
    const [selectedBomCode, setSelectedBomCode] = React.useState<string>('');
    const [multipleBomDialogApi, setMultipleBomDialogApi] = React.useState<BomApis>(null);

    const resetStates = () => {
        setMultipleBomState(false);
        setBomList([]);
        setKitStatus('');
        setSelectedBomCode('');
        setMultipleBomDialogApi(null);
    };

    const validate = (response: any) => {
        if (!response.Forms) {
            return;
        }
        const form = response.Forms?.[0];

        if (form?.FormId === 'SelectBomCode') {
            setBomList((response?.KitDetail) ?? [] as any);
            setKitStatus((response?.KitStatus) ?? '');
            setSelectedBomCode((response?.BomCode) ?? '');
            setMultipleBomDialogApi(response?.multipleBomDialogApi ?? null);
            setMultipleBomState(true);
        }
    };

    return {
        bomList,
        kitStatus,
        selectedBomCode,
        multipleBomOpen,
        multipleBomDialogApi,
        resetStates,
        setMultipleBomDialogApi,
        validate,
        setBomList,
        setKitStatus,
        setSelectedBomCode,
        setMultipleBomState
    };
};
